/**
 * How a `cs-rep-progress-bar` fill is coloured. Kept in its own Angular-free file so the pure
 * display helpers in `pages/workout-detail/set-progress-display.ts` can pick a tone without
 * importing the component.
 */
export enum RepProgressBarTone {
  /** grey */
  Neutral = 'neutral',
  /** green */
  Progress = 'progress',
}
